import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=56fa169e"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=56fa169e&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56fa169e')) {
      api.createRecord('56fa169e', component.options)
    } else {
      api.reload('56fa169e', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=56fa169e", function () {
      api.rerender('56fa169e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/creditInfo/lawsRegulations/detail.vue"
export default component.exports